import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import "./Sidebar.css";
import Avatar from "../../component/avatar/Avatar";
import Text from "../../component/text/Text";
import MenuIcon from "../../image/hamburgerDotMenu.svg";
import LogoutIcon from "./img/LogoutIcon.svg";
import SwitchAgencyIcon from "./img/switchAgency.svg";
import ProfileIcon from "./img/ProfileIcon.svg";
import { Popover } from "react-tiny-popover";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import ProfileModal from "../../component/modal/ProfileModal";
import { useAuth } from "../../config/utilities/useAuth";
import { useIsTablet } from "../../config/utilities/useBreakpoint";
import { formatCapitalize } from "../../config/utilities/formatCapitalize";

const formatRoleLabel = (role) => {
  if (!role) return "";
  if (role === "SUPERADMIN") return "Superadmin";
  return formatCapitalize(role);
};

const SidebarAccount = () => {
  const [userName, setUserName] = useState("");
  const [userInstitution, setUserInstitution] = useState("");
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const isMobileViewport = useIsTablet();
  const navigate = useNavigate();
  const [instCount, setInstCount] = useState(0);
  const [openProfle, setOpenProfile] = useState(false);

  const { privilege, privilegeSelection } = useAuth();
  const role =
    privilege?.role ||
    privilegeSelection?.find((p) => p.role === "SUPERADMIN")?.role;
  const accountSubtitle =
    userInstitution || formatRoleLabel(role);

  useEffect(() => {
    const updateUserData = () => {
      setUserName(Cookies.get("name") || "");
      setUserInstitution(Cookies.get("institutionName") || "");
      setInstCount(Cookies.get("instCount") || 0);
    };

    updateUserData();

    window.addEventListener("cookieUpdate", updateUserData);

    return () => {
      window.removeEventListener("cookieUpdate", updateUserData);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      Cookies.remove("name");
      Cookies.remove("institutionId");
      Cookies.remove("email");
      Cookies.remove("instCount");
      sessionStorage.removeItem("masterAdminSelectedInstitutionId");
      navigate("/login");
      setIsPopoverOpen(false);
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  const handleInstitutionSwitch = () => {
    navigate("/institutionselector");
  };

  const handleToggleProfile = () => {
    setIsPopoverOpen(!isPopoverOpen);
    setOpenProfile(!openProfle);
  };

  return (
    <>
      <div className="sidebar-account">
        <div className="account-container">
          <Avatar
            name={userName}
            size="3rem"
            fontSize="1.5rem"
            lineHeight="3rem"
          />
          <div className="account-details">
            <Text
              text={userName}
              color="#101828"
              size="0.875rem"
              weight="600"
              align="left"
            />
            <Text
              text={accountSubtitle}
              color="#6B7280"
              size="0.8rem"
              align="left"
            />
          </div>
          <Popover
            isOpen={isPopoverOpen}
            positions={
              isMobileViewport ? ["top", "bottom", "left"] : ["right", "bottom", "top"]
            }
            align="start"
            padding={8}
            reposition
            onClickOutside={() => setIsPopoverOpen(false)}
            containerStyle={{ zIndex: 10000 }}
            content={
              <div className={`popover-content ${isPopoverOpen ? "show" : ""}`}>
                <button onClick={handleToggleProfile} className="logout-button">
                  <img
                    src={ProfileIcon}
                    alt="Users Icon"
                    className="logout-icon"
                  />
                  Manage Profile
                </button>
                {(role === "SUPERADMIN" || instCount > 1) && (
                  <button
                    onClick={handleInstitutionSwitch}
                    className="logout-button"
                  >
                    <img
                      src={SwitchAgencyIcon}
                      alt="Switch Agency Icon"
                      className="logout-icon"
                    />
                    Institution Workspace
                  </button>
                )}
                <button onClick={handleLogout} className="logout-button">
                  <img
                    src={LogoutIcon}
                    alt="Logout Icon"
                    className="logout-icon"
                  />
                  Log out
                </button>
              </div>
            }
          >
            <button
              className="menu-button"
              onClick={() => setIsPopoverOpen(!isPopoverOpen)}
            >
              <img src={MenuIcon} alt="Menu Icon" className="menu-icon" />
            </button>
          </Popover>
        </div>
      </div>
      {openProfle && (
        <ProfileModal
          isOpen={openProfle}
          onClose={() => handleToggleProfile()}
        />
      )}
    </>
  );
};

export default SidebarAccount;
